import { compose } from 'redux';
import type { VehiclesTabState } from './reducer';

import type { AppState } from '../AppState';

export const selectVehiclesTabDomain = (state: AppState): VehiclesTabState => state.vehiclesTab;

export const selectEtaVehicles = compose((domainState: VehiclesTabState) => domainState.etaVehiclesWebData, selectVehiclesTabDomain);

export const selectEtaRoute = compose((domainState: VehiclesTabState) => domainState.etaRouteWebData, selectVehiclesTabDomain);

export const selectIsEtaDialogOpen = compose((domainState: VehiclesTabState) => domainState.isEtaDialogOpen, selectVehiclesTabDomain);

export const selectDestination = compose((domainState: VehiclesTabState) => domainState.destination, selectVehiclesTabDomain);

export const selectEtaDevice = compose((domainState: VehiclesTabState) => domainState.etaDevice, selectVehiclesTabDomain);
